<div class="alignment">
  <button mat-icon-button
          [class.active]="alignment === textAlignment.Start"
          (click)="setAlignment(textAlignment.Start)"
  >
    <img [src]="alignLeftUrl"/>
  </button
  ><button mat-icon-button
           [class.active]="alignment === textAlignment.Middle"
           (click)="setAlignment(textAlignment.Middle)"
  >
    <img [src]="alignMiddleUrl"/>
  </button
  ><button mat-icon-button
           [class.active]="alignment === textAlignment.End"
           (click)="setAlignment(textAlignment.End)"
  >
    <img [src]="alignRightUrl"/>
  </button>
</div>
